module.exports = __webpack_public_path__ + "static/search-eb8758fd0be42431330b64c596fa9976.png";